class WardrobeCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('change', this.handleChange);
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-cart-quantity-action]');
    if (!button || !this.contains(button)) return;

    const row = button.closest('[data-cart-line]');
    const input = row?.querySelector('[data-cart-quantity-input]');
    if (!row || !input || this.hasAttribute('data-updating')) return;

    const direction = button.dataset.cartQuantityAction === 'increase' ? 1 : -1;
    const current = Number.parseInt(input.value, 10) || 0;
    const minimum = Number.parseInt(input.min, 10) || 0;
    const maximum = input.max ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
    const next = Math.min(maximum, Math.max(minimum, current + direction));

    if (next === current) return;
    input.value = String(next);
    this.updateLine(row.dataset.cartLine, next);
  };

  handleChange = (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input || !this.contains(input) || this.hasAttribute('data-updating')) return;

    const row = input.closest('[data-cart-line]');
    if (!row) return;

    const minimum = Number.parseInt(input.min, 10) || 0;
    const maximum = input.max ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
    const requested = Number.parseInt(input.value, 10) || minimum;
    const quantity = Math.min(maximum, Math.max(minimum, requested));

    input.value = String(quantity);
    this.updateLine(row.dataset.cartLine, quantity);
  };

  async updateLine(line, quantity) {
    const status = this.querySelector('[data-cart-status]');
    const root = window.Shopify?.routes?.root || '/';
    const changeUrl = window.Theme?.routes?.cart_change_url || `${root}cart/change.js`;

    this.setAttribute('data-updating', '');
    if (status) status.textContent = 'Updating your shopping bag…';

    try {
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line: Number.parseInt(line, 10),
          quantity,
        }),
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || result.message || 'Unable to update the cart.');
      }

      window.location.reload();
    } catch (error) {
      this.removeAttribute('data-updating');
      if (status) status.textContent = error.message;
    }
  }
}

if (!customElements.get('wardrobe-cart')) {
  customElements.define('wardrobe-cart', WardrobeCart);
}
